import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const RouteChangeHandler = () => {
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    const prev = prevPathRef.current;
    const current = location.pathname;

    // Attendance
    const wasInAttendance = prev.startsWith("/attendance-view");
    const isInAttendance = current.startsWith("/attendance-view");

    if (wasInAttendance && !isInAttendance) {
      console.log("Leaving attendance → clearing attendance filters");
      localStorage.removeItem("attendanceFilters");
      localStorage.removeItem("attendanceCalendarFilters");
    }

    // Leave
    const leaveWhitelist = [
      "/leave/leave-request",
      "/leave/leave-balance",
      "/leave-calendar",
    ];
    const isInLeaveWhitelist = leaveWhitelist.some((path) =>
      current.startsWith(path)
    );
    const wasInLeaveWhitelist = leaveWhitelist.some((path) =>
      prev.startsWith(path)
    );

    if (wasInLeaveWhitelist && !isInLeaveWhitelist) {
      console.log("Leaving leave views → clearing leave filters");
      localStorage.removeItem("LeaveRequestFilters");
      localStorage.removeItem("LeaveBalanceFilters");
      localStorage.removeItem("LeaveCalendarFilters");
    }

    // Update reference
    prevPathRef.current = current;
  }, [location.pathname]);

  return null;
};

export default RouteChangeHandler;
